import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import { CartComponent } from '../../../shared/components';

@Component({
  selector: 'app-navigation',
  imports: [CommonModule, FontAwesomeModule, CartComponent, RouterLink],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {

  //#region Font Awesome Icons
  iconPhone = faPhone;

  iconFacebook = faFacebook;
  iconInstagram = faInstagram;
  iconTiktok = faTiktok;
  //#endregion
}
